import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

import MarkdownLink from '@/components/MarkdownText/MarkdownLink';
import classNames from '@/helpers/classNames';

import styles from './MarkdownText.module.scss';

interface MarkdownTextProps {
  children?: string;
  className?: string;
}

const MarkdownText: FC<MarkdownTextProps> = ({ children, className }) => {
  if (!children || typeof children !== 'string') {
    return null;
  }

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkBreaks]}
      className={classNames([styles.container, className])}
      components={{ a: MarkdownLink }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default MarkdownText;
